module.exports = __webpack_public_path__ + "pharmabox-mockup.svg?4add252e3193e6263850761a0fde574b";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/pharmabox-mockup.svg
// module id = 307
// module chunks = 0